import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=e319bf9a"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports